// @flow
import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import {Link, Route, Switch, useLocation, useHistory} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import {ButtonGroup, Grid} from '@material-ui/core';
import AlertDueDateTier from '../../tiers/components/AlertDueDateTier/AlertDueDateTier';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import ShareIcon from '@material-ui/icons/Share';

import {
  ArrowBack,
  HelpTwoTone,
  InfoOutlined,
  PlayCircleFilledTwoTone,
  Language,
  Dvr,
  Web,
} from '@material-ui/icons';
import {colors} from '../../../assets/styles/colors';

import SocialMediasContainer from '../../configure/social-medias/containers/SocialMediasContainer';
import {useIsFeatureInTier} from '../../../utils/component';

import DomainContainer from '../../domain/containers/DomainContainer';
import {TIENDADA_LINKS} from '../../../constants';

import type {User, Store} from '../../../entities';
import type {Node} from 'react';
import BlogContainer from '../../blog/container/BlogContainer';
import ConfigPagesContainer from '../config-pages/containers/ConfigPagesContainer';
import PremiumFeatureBadge from '../../../elements/PremiumFeatureBadge/PremiumFeatureBadge';

type MyStoreSubRoute = {
  name: string | Node,
  path: string,
  component?: Node,
  icon: Node,
  disabled?: boolean,
  tierRestricted?: boolean,
  showChip?: boolean,
  showBackButton?: boolean,
};

type Props = {
  store: Store,
  user: User,
};

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1400,
    // minHeight: '100%',
    // overflow: 'auto',
    padding: '1rem',
    [theme.breakpoints.down('xs')]: {
      padding: '.5rem',
    },
  },
  dividerVertical: {
    margin: theme.spacing(0, 1),
    background: colors.grey300,
  },
  contentBottom: {
    // flexGrow: 1,
    // paddingTop: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    // height: '100%',
    // marginBottom: 64,
    background: '#f8f9fb',
    // overflow: 'auto',
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down('sm')]: {
      marginBottom: 140,
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2),
    },
  },
  headerWrapper: {
    // background: '#f8f9fb',
    // marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
  ayudaButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    margin: '0 14px 0 0',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      fontSize: '12px',
      margin: '0 16px 0 0',
      padding: 0,
      boxShadow: 'unset',
    },
  },
  tutorialsButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      padding: 0,
      boxShadow: 'unset',
    },
  },
  subRouteHeader: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: 12,
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // textAlign: 'left',
    // justifyContent: 'flex-start',
    backgroundColor: colors.grey300,
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  upsellMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      // flexDirection: 'column',
      padding: theme.spacing(1),
      flexWrap: 'wrap',
    },
    color: colors.purple3,
    background: colors.lightPurple,
    // opacity: 0.8,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  upgradeTierButton: {
    marginLeft: 'auto',
    // backgroundColor: 'white',
    // color: colors.purple3,
    // padding: '4px 13px',
    // boxShadow:
    //   '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    backgroundColor: 'unset',
    color: colors.purple3,
    boxShadow: 'unset',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
      // backgroundColor: 'unset',
      // color: colors.purple3,
      // padding: 0,
      // boxShadow: 'unset',
    },
  },
  myStoreButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  disabledMyStoreButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  groupButton: {
    width: '100%',
    justifySelf: 'flex-end',
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    // justifyContent: 'flex-start',
    border: 'none',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  subRouteIcon: {
    fontSize: '1.5rem !important',
    marginRight: 12,
  },
  subRouteNameWrap: {
    height: 56,
    position: 'sticky',
    top: 72,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    color: colors.grey700,
    backgroundColor: colors.grey200,
    padding: theme.spacing(2),
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  subRouteNameText: {
    fontWeight: 600,
    fontSize: '1.125rem',
  },
  upsellMessageBottom: {
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    maxWidth: 670,
    // justifyContent: 'space-between',
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      bottom: 64,
      left: 0,
    },
    color: colors.purple3,
    background: colors.lightPurple,
    // opacity: 0.8,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  newLabel: {
    background: '#F5F0FF',
    marginLeft: 10,
    fontWeight: 600,
    '& span': {
      color: '#7B39FF',
    },
  },
}));

function getTutorialLinkByPathname(pathname: string) {
  if (pathname.includes('domain')) {
    return TIENDADA_LINKS.tutorials.CUSTOM_DOMAIN;
  }
  if (pathname.includes('social-medias')) {
    return TIENDADA_LINKS.tutorials.SOCIAL_MEDIA;
  }
  if (pathname.includes('pages')) {
    return TIENDADA_LINKS.tutorials.PAGES;
  }
  if (pathname.includes('blog')) {
    return TIENDADA_LINKS.tutorials.BLOG;
  }

  return TIENDADA_LINKS.tutorials.GENERAL;
}
export default function MyStore(props: Props) {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const hasTemplateFeature = useIsFeatureInTier('STOREFRONT_TEMPLATES');
  const hasLegalFeature = useIsFeatureInTier('STORE_POLICIES');

  const subRoutes: {[key: string]: MyStoreSubRoute} = {
    // myBrand: {
    //   name: 'Mi Marca',
    //   path: '/my-store/cover-customize',
    //   component: <CoverCustomizeContainer />,
    //   icon: <FormatColorText className={classes.subRouteIcon} />,
    //   tierRestricted: false,
    //   showChip: false,
    // },
    // customizeStore: {
    //   name: (
    //     <div style={{display: 'flex', alignItems: 'center'}}>
    //       Personalizar Tienda
    //       <Chip
    //         label={hasTemplateFeature ? 'NUEVO' : 'PRO+'}
    //         size="small"
    //         className={classes.newLabel}
    //       />
    //     </div>
    //   ),
    //   path: '/my-store/customize',
    //   component: <CustomizeContainer />,
    //   icon: <Palette className={classes.subRouteIcon} />,
    //   tierRestricted: false,
    //   showChip: true,
    // },
    domain: {
      name: 'Dominios',
      path: '/my-store/domain',
      component: <DomainContainer />,
      icon: <Language className={classes.subRouteIcon} />,
    },
    socialMedias: {
      name: 'Redes Sociales',
      path: '/my-store/social-medias',
      component: <SocialMediasContainer />,
      icon: <ShareIcon className={classes.subRouteIcon} />,
    },
    // productPages: {
    //   name: 'Configuración de Página de producto',
    //   path: '/my-store/product-page',
    //   component: <ProductPageConfigurationContainer />,
    //   icon: <PageviewIcon className={classes.subRouteIcon} />,
    // },
    pages: {
      name: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          Páginas
          {!hasLegalFeature && <PremiumFeatureBadge />}
        </div>
      ),
      path: '/my-store/pages',
      component: <ConfigPagesContainer />,
      icon: <Dvr className={classes.subRouteIcon} />,
    },
    blog: {
      name: 'Blog',
      path: '/my-store/blog',
      component: <BlogContainer />,
      icon: <Web className={classes.startIcon} />,
      showBackButton: true,
    },
    // legal: {
    //   name: (
    //     <div style={{display: 'flex', alignItems: 'center'}}>
    //       Páginas
    //       <Chip
    //         label={hasLegalFeature ? 'NUEVO' : 'PRO+'}
    //         size="small"
    //         className={classes.newLabel}
    //       />
    //     </div>
    //   ),
    //   path: '/my-store/legal',
    //   component: <LegalContainer />,
    //   icon: <Dvr className={classes.subRouteIcon} />,
    // },
    // homePages: {
    //   name: (
    //     <div style={{display: 'flex', alignItems: 'center'}}>
    //       Páginas de inicio
    //       <Chip label="NUEVO" size="small" className={classes.newLabel} />
    //     </div>
    //   ),
    //   path: '/my-store/home-page',
    //   component: <HomePageContainer />,
    //   icon: <Dvr className={classes.subRouteIcon} />,
    // },
    /* seo: {
      name: 'SEO',
      path: '...',
      disabled: true,
      component: <div>coming soon</div>,
      icon: <FindInPage className={classes.subRouteIcon} />,
    }, */
  };

  const subRoutesArray = Object.keys(subRoutes).map(k => subRoutes[k]);

  const subRoute: ?MyStoreSubRoute = subRoutesArray.find(
    (route: MyStoreSubRoute) => location.pathname.startsWith(route.path)
  );

  return (
    <div className={classes.root}>
      <AlertDueDateTier />
      {subRoute && (
        <Hidden mdUp>
          <div className={classes.subRouteNameWrap}>
            <CustomButton to="/my-store">
              <ArrowBack />
            </CustomButton>
            {subRoute.icon}
            <Typography component={'span'} className={classes.subRouteNameText}>
              {subRoute.name}
            </Typography>
          </div>
        </Hidden>
      )}

      <main className={classes.content}>
        <Hidden smDown>
          <div className={classes.headerWrapper}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Typography className={classes.title}>Tu tienda</Typography>
              </Grid>
              <Grid item>
                <CustomButton
                  href={TIENDADA_LINKS.customerSupport.general}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.ayudaButton}
                  startIcon={<HelpTwoTone />}
                >
                  Ayuda
                </CustomButton>
                <CustomButton
                  href={getTutorialLinkByPathname(location.pathname)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.tutorialsButton}
                  startIcon={<PlayCircleFilledTwoTone />}
                >
                  Tutoriales
                </CustomButton>
              </Grid>
            </Grid>
            {subRoute && (
              <div className={classes.subRouteHeader}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  {subRoute.showBackButton && (
                    <CustomButton onClick={() => history.goBack()}>
                      <ArrowBack />
                    </CustomButton>
                  )}
                  {subRoute.icon} {subRoute.name}
                </div>
                {subRoute.showChip && (
                  <div>{!hasTemplateFeature && <PremiumFeatureBadge />}</div>
                )}
              </div>
            )}
          </div>
        </Hidden>
        {subRoute && subRoute.tierRestricted && (
          <div className={classes.upsellMessage}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <InfoOutlined style={{marginRight: 16}} />
              Suscríbete a nuestros planes para acceder a funcionalidades PRO e
              impulsar tu negocio
            </div>
            <CustomButton
              className={classes.upgradeTierButton}
              to="/tiers-list"
            >
              Mejorar Plan
            </CustomButton>
          </div>
        )}
        <Switch>
          <Route exact path="/my-store">
            <>
              {subRoutesArray.map((route: MyStoreSubRoute, idx: number) => (
                <CustomButton
                  key={idx}
                  startIcon={route.icon}
                  disabled={route.disabled}
                  component={Link}
                  to={route.path}
                  className={`${
                    route.disabled
                      ? classes.disabledMyStoreButton
                      : classes.myStoreButton
                  }`}
                >
                  {route.name}
                </CustomButton>
              ))}
            </>
          </Route>
          {subRoutesArray.map((route: MyStoreSubRoute, idx: number) => (
            <Route key={`my-store-route-${idx}`} path={route.path}>
              <div className={classes.subRouteContent}>{route.component}</div>
            </Route>
          ))}
        </Switch>
      </main>
      <div className={classes.contentBottom}>
        <Hidden mdUp>
          <ButtonGroup>
            <CustomButton
              href={getTutorialLinkByPathname(location.pathname)}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<PlayCircleFilledTwoTone />}
            >
              Tutoriales
            </CustomButton>
            <CustomButton
              href={TIENDADA_LINKS.customerSupport.general}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<HelpTwoTone />}
            >
              Ayuda
            </CustomButton>
          </ButtonGroup>
        </Hidden>
      </div>
    </div>
  );
}
